<template>
    <div class="relative w-full h-screen overflow-hidden bg-gray-100 flex items-center">
        <div
            class="w-full h-full flex transition-transform duration-700 ease-in-out"
            :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
        >
            <!-- Slides -->
            <div
                v-for="(slide, index) in sliderImages"
                :key="'slider-' + index"
                class="w-full h-full flex-shrink-0 relative bg-no-repeat bg-right bg-cover md:bg-center md:bg-cover"
                :style="{ backgroundImage: `url(${slide.image_path})` }"
            >
                <!-- Overlay -->
                <div class="absolute inset-0 bg-black bg-opacity-30"></div>

                <!-- Content -->
                <div class="relative z-10 flex flex-col justify-center h-full px-4 md:px-20 text-white w-full">
                    <div class="absolute bottom-48 left-2 md:left-20 max-w-full md:max-w-xl">
                        <h2 class="text-4xl font-bold mb-4 break-words whitespace-normal">
                            {{ slide.title || 'Big Sale!' }}
                        </h2>
                        <p class="text-lg mb-6">{{ slide.description || 'Shop the best products now.' }}</p>
                        <div class="w-fit mb-4">
                            <inertia-link
                                variant="success"
                                href="/products"
                                class="inline-block bg-green-600 hover:bg-green-700 px-6 py-3 rounded text-white font-medium"
                            >
                                {{ slide.button_text || 'Shop Now' }}
                            </inertia-link>
                        </div>
                    </div>
                    <!-- Navigation Arrows placed below -->
                    <div class="absolute bottom-6 right-20 -translate-x-1/2 z-20 flex gap-4">
                        <button
                            @click="prevSlide"
                            class="bg-green-600 text-white w-10 h-10 rounded-full hover:bg-green-700 flex items-center justify-center"
                        >
                            <svg
                                class="w-3 h-3"
                                fill="currentColor"
                                viewBox="0 0 320 512"
                            >
                                <path
                                    d="M34.524 239.03L228.868 44.686c9.373-9.373 24.569-9.373 33.941 0l22.667 22.667c9.357 9.357 9.375 24.522.04 33.901L131.495 256l154.021 154.745c9.335 9.379 9.317 24.544-.04 33.901l-22.667 22.667c-9.373 9.373-24.569 9.373-33.941 0L34.525 272.971c-9.373-9.372-9.373-24.568-.001-33.941z"
                                />
                            </svg>
                        </button>
                        <button
                            @click="nextSlide"
                            class="bg-green-600 text-white w-10 h-10 rounded-full hover:bg-green-700 flex items-center justify-center"
                        >
                            <svg
                                class="w-3 h-3"
                                fill="currentColor"
                                viewBox="0 0 320 512"
                            >
                                <path
                                    d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Navigation Arrows -->
        <!-- <button
            @click="prevSlide"
            class="absolute left-4 top-1/2 bg-green-500 transform -translate-y-1/2 bg-black/50 text-white w-10 h-10 rounded-full z-10 hover:bg-black/70 flex items-center justify-center"
        >
            <svg
                class="w-3 h-3 mx-2 text-white-400"
                fill="currentColor"
                viewBox="0 0 320 512"
            >
                <path
                    d="M34.524 239.03L228.868 44.686c9.373-9.373 24.569-9.373 33.941 0l22.667 22.667c9.357 9.357 9.375 24.522.04 33.901L131.495 256l154.021 154.745c9.335 9.379 9.317 24.544-.04 33.901l-22.667 22.667c-9.373 9.373-24.569 9.373-33.941 0L34.525 272.971c-9.373-9.372-9.373-24.568-.001-33.941z"
                />
            </svg>
        </button>
        <button
            @click="nextSlide"
            class="absolute right-4 top-1/2 bg-green-500 transform -translate-y-1/2 bg-black/50 text-white w-10 h-10 rounded-full z-10 hover:bg-black/70 flex items-center justify-center"
        >
            <svg
                class="w-3 h-3 mx-2 text-white-400"
                fill="currentColor"
                viewBox="0 0 320 512"
            >
                <path
                    d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                />
            </svg>
        </button> -->
    </div>
</template>

<script>
    export default {
        props: {
            sliderImages: {
                type: Array,
                required: true,
                default: () => [],
            },
        },
        data() {
            return {
                currentSlide: 0,
                autoSlideInterval: null,
            };
        },
        mounted() {
            this.startAutoSlide();
        },
        beforeDestroy() {
            clearInterval(this.autoSlideInterval);
        },
        methods: {
            nextSlide() {
                this.currentSlide = (this.currentSlide + 1) % this.sliderImages.length;
            },
            prevSlide() {
                this.currentSlide = (this.currentSlide - 1 + this.sliderImages.length) % this.sliderImages.length;
            },
            startAutoSlide() {
                this.autoSlideInterval = setInterval(() => {
                    this.nextSlide();
                }, 5000); // Change slide every 5s
            },
        },
    };
</script>

<style scoped>
    /* Optional: Override styles or add transitions */
</style>
